/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { detectIncognito } from 'detectincognitojs';
import { NO_SUBSCRIPTION_MESSAGE } from 'constants/messages';
import { isNoSubscriptionEntitlementError, notifyNoSubscriptionEntitlement } from 'utils/entitlements';
import { getDeployment } from './deployment';
// import { LOGIN_USER_TYPES } from 'constants';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:7091/', withCredentials: true });

axiosServices.interceptors.request.use(
    async (config) => {
        // const pathname = window.location.pathname;
        // let currentUserType = LOGIN_USER_TYPES.ASSESSOR;
        // if (pathname === '/candidate' || pathname.startsWith('/candidate/')) currentUserType = LOGIN_USER_TYPES.CANDIDATE;
        // if (pathname === '/guest' || pathname.startsWith('/guest/')) currentUserType = LOGIN_USER_TYPES.GUEST;

        // config.headers['ROBOT-USER-TYPE'] = currentUserType;

        const accessToken = localStorage.getItem('serviceToken');
        const publicIp = localStorage.getItem('public-ip');

        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        // for private browsing
        await detectIncognito().then((result) => {
            config.headers['robot-browser'] = result.browserName;
            config.headers['robot-browser-private'] = result.isPrivate ? 'private' : 'normal';
        });

        if (publicIp) {
            config.headers['public-ip'] = publicIp;
        }

        // check if deployment group or not
        config.headers['x-deployment'] = getDeployment();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        const errorData = (error.response && error.response.data) || 'Wrong Services';

        if (isNoSubscriptionEntitlementError(errorData)) {
            notifyNoSubscriptionEntitlement();

            return Promise.reject({
                ...(typeof errorData === 'string' ? {} : errorData),
                message: NO_SUBSCRIPTION_MESSAGE,
                error: NO_SUBSCRIPTION_MESSAGE,
                isNoSubscriptionEntitlement: true
            });
        }

        return Promise.reject(errorData);
    }
);

// axiosServices.defaults.headers.common['x-deployment'] = getDeployment();

export default axiosServices;
